import {get, debounce, toNumber} from "lodash";

export default {
	props: {
		productId: {type: Number, required: true},
		variantId: {type: Number, required: true},
		rules: {type: Object, required: true},
	},
	computed: {
		quantityC: {
			get() {
				return this.counter.hasOwnProperty(this.variantId) ? this.counter[this.variantId] : this.quantity || 0;
			},
			set(quantity) {
				// convert to number
				quantity = parseInt(quantity) || 0;

				// limit quantity to max
				quantity = this.maxQuantity && quantity > this.maxQuantity ? this.maxQuantity : quantity;

				// force incrementBy on quantity
				const mod = quantity % this.incrementBy;
				if (mod !== 0) quantity = quantity - mod;

				// update counter
				this.$store.commit("cart/counter", {[this.variantId]: quantity});
			}
		},
		incrementBy: (t) => t.rules.increment_by,
		quantity: (t) => get(t.cartItem, "quantity"),
		maxQuantity: (t) => t.rules.inventory_quantity,
		counter: (t) => t.$store.getters["cart/counter"],
		cartItems: (t) => t.$store.getters["cart/items"] || [],
		cartItem: (t) => t.cartItems.find(x => x.variant_id === t.variantId)
	},
	methods: {
		increment({q}) {
			const quantity = (q * this.incrementBy) + this.quantityC;

			if (quantity >= 0) {
				this.quantityC = quantity;
				this.update({quantity: this.quantityC});
			}
		},

		inputKey(e) { // only allow numbers
			if (isNaN(toNumber(e.key))) e.preventDefault();
		},

		input(e) {
			this.quantityC = e.target.value;
			this.update({quantity: this.quantityC});
		},

		async update({quantity}) {
			await this.$store.dispatch("cart/updateItem", {variantId: this.variantId, quantity});
		}
	},
	created() {
		this.update = debounce(this.update, 500);
	},
	render() {
		return this.$scopedSlots.default({
			increment: this.increment,
			quantityC: this.quantityC,
			inputKey: this.inputKey,
			cartItem: this.cartItem,
			input: debounce((e) => this.input(e), this.incrementBy > 1 ? 500 : 0)
		});
	}
};
